import { render } from "./ManageAuctions.vue?vue&type=template&id=561fd0c3&scoped=true"
import script from "./ManageAuctions.vue?vue&type=script&lang=js"
export * from "./ManageAuctions.vue?vue&type=script&lang=js"

import "./ManageAuctions.vue?vue&type=style&index=0&id=561fd0c3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561fd0c3"]])

export default __exports__